import { useNavigate } from "react-router-dom";
import PaginationLayout from "../../components/pagination/PaginationLayout";
import PaymentStatusPill from "../../components/payments/PaymentStatusPill";
import EmptyTableRow from "../../components/table/EmptyTableRow";
import TableContainer from "../../components/table/TableContainer";
import TableRow from "../../components/table/TableRow";
import { UserRole } from "../../utils/api/endpoints/user/credentials";
import useTransactions from "../../utils/hooks/payments/useTransactions";
import useUserCredentials from "../../utils/hooks/user/useUserCredentials";

const PaginatedTransactions = () => {
  const { role } = useUserCredentials();
  const { transactions, count, filters, isError, isLoading, setPage } =
    useTransactions();
  const navigate = useNavigate();

  return (
    <div className="relative flex h-full flex-col">
      <PaginationLayout
        page={filters.page || 0}
        count={filters.limit}
        totalItems={count}
        setPage={setPage}
      >
        <div className="col-span-5 flex flex-col gap-12">
          <div className="flex items-center justify-between">
            <h1 className="text-3xl font-bold leading-[150%] text-ctb-blue">
              Payments
            </h1>

            {role === UserRole.RESEARCHER && (
              <button
                onClick={() => navigate("/dashboard/profile/settings/payments")}
                className="font-medium text-ctb-blue-200"
              >
                Update payment details
              </button>
            )}
          </div>

          {/* TODO: Add statistics cards w/ payment summary when dashbaords have been merged */}

          <TableContainer
            columns={[
              {
                name: "Amount"
              },
              {
                name: "User"
              },
              {
                name: "Date"
              },
              {
                name: "Status"
              }
            ]}
          >
            {isLoading ? (
              <EmptyTableRow message="Loading transactions..." />
            ) : isError ? (
              <EmptyTableRow message="Failed to load transactions" />
            ) : transactions.length === 0 ? (
              <EmptyTableRow message="No transactions" />
            ) : (
              transactions.map((transaction, index) => (
                <TableRow key={index}>
                  <p>$ {transaction.amount.toFixed(2)}</p>
                  <p>
                    {transaction.researcher.displayName ||
                      transaction.researcher.username}
                  </p>
                  <p>{transaction.updatedAt}</p>
                  <PaymentStatusPill status={transaction.status} />
                </TableRow>
              ))
            )}
          </TableContainer>
        </div>
      </PaginationLayout>
    </div>
  );
};

export default PaginatedTransactions;
